// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","525":"component---src-pages-reading-js"}[chunkId] + "-" + {"125":"dbe3e5b0810dde209585","293":"95ee70c4e085b7fa3fd2","525":"581c23748553f62ac9bd"}[chunkId] + ".js";
};